/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Sidebar_Open_MenuInputs */

const en_directory_sidebar_open_menu = /** @type {(inputs: Directory_Sidebar_Open_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open menu`)
};

const zh_directory_sidebar_open_menu = /** @type {(inputs: Directory_Sidebar_Open_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开菜单`)
};

/**
* | output |
* | --- |
* | "Open menu" |
*
* @param {Directory_Sidebar_Open_MenuInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_sidebar_open_menu = /** @type {((inputs?: Directory_Sidebar_Open_MenuInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Sidebar_Open_MenuInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_sidebar_open_menu(inputs)
	return zh_directory_sidebar_open_menu(inputs)
});
export { directory_sidebar_open_menu as "directory.sidebar.open_menu" }